if (!customElements.get("store-locator-slider")) {
  class StoreLocatorSlider extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener(
          "shopify:section:load",
          this.init.bind(this)
        );
      }
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.init();
      window.addEventListener("resize", this.handleResize);
      window.addEventListener("orientationchange", this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("orientationchange", this.handleResize);
    }

    init() {
      this.hasMapLayout = this.classList.contains("store-locator__map-cards");
      this.updateSwiper();
    }

    handleResize() {
      this.updateSwiper();
    }

    updateSwiper() {
      const screenWidth = window.innerWidth;

      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      if (this.hasMapLayout && screenWidth > 990) {
        return;
      }

      const autoplayOptions = {
        delay: this.dataset.autoplayInterval
      };

      const swiperSettings = {
        slidesPerView: 1,
        navigation: {
          nextEl: `.swiper-button--next-${this.dataset.sectionId}`,
          prevEl: `.swiper-button--prev-${this.dataset.sectionId}`
        },
        spaceBetween: parseInt(this.dataset.spaceBetween) || 12,
        scrollbar: {
          el: `.swiper-scrollbar-${this.dataset.sectionId}`,
          draggable: true
        },
        pagination: {
          el: ".store-locator__pagination",
          clickable: true,
          renderBullet: function (i, className) {
            return `
            <button class="${className}">
              <span>0${i + 1}</span>
              <svg class="square-progress" width="26" height="26">
                <rect class="square-origin" width="26" height="26" rx="5" ry="5" />
              </svg>
              <svg class="progress" width="18" height="18" style="inset-inline-start: ${
                0 - (i * 2.4 + 3.4)
              }rem">
                <circle class="circle-origin" r="8" cx="9.5" cy="9.5"></circle>
              </svg>
            </button>
            `;
          }
        },
        autoplay: this.dataset.autoplay === "true" ? autoplayOptions : false,
        on: {
          init: this.handleSlideChange.bind(this),
          slideChange: this.handleSlideChange.bind(this),
          transitionEnd: this.handleTransitionEnd.bind(this)
        }
      };

      if (!this.hasMapLayout) {
        swiperSettings.breakpoints = {
          1200: {
            slidesPerView: (parseInt(this.dataset.slidesPerView) * 1.02) || 2,
          },
          750: {
            slidesPerView: 2,
          },
          360: {
            slidesPerView: 1.08,
          },
        };
      }

      // For mobile slider, use the pagination inside the slider
      if (this.classList.contains('small-up-hide')) {
        swiperSettings.pagination.el = ".swiper-pagination";
      } else {
        // For desktop slider, check if we're on mobile and use mobile pagination
        if (screenWidth <= 749) {
          swiperSettings.pagination.el = "#mobile-pagination-" + this.dataset.sectionId;
        } else {
          // For desktop, use the header pagination
          swiperSettings.pagination.el = "#desktop-pagination-" + this.dataset.sectionId;
        }
      }

      this.slider = new Swiper(this, swiperSettings);
    }

    handleSlideChange(swiper) {
      // This method ensures pagination bullets update properly with autoplay
      // The pagination will automatically update when slideChange is triggered
    }

    handleTransitionEnd(swiper) {
      const slides = this.querySelectorAll(
        ".store-locator-card.swiper-slide"
      );
      slides.forEach((slide) => {
        slide.style.display = "block";
      });
    }
  }

  customElements.define("store-locator-slider", StoreLocatorSlider);
}
